// extracted by mini-css-extract-plugin
module.exports = {"reportSection":"ReportSection_reportSection__1ZPDQ","noData":"ReportSection_noData__1J6tX","loader":"ReportSection_loader__i0o57"};